import { METERS_TO_MILES_CONSTANT } from '../constants';
import { DistanceUnit } from '../store/mst/models';

const getFormattedDistance = (distance: number | undefined | null, format: DistanceUnit, numDecimals?: number): number | undefined => {
  if (distance) {
    const convertedDistance = format === DistanceUnit.KM ? distance / 1000 : distance * METERS_TO_MILES_CONSTANT;
    return numDecimals ? Number(convertedDistance.toFixed(numDecimals)) : Number(Math.round(convertedDistance));
  }
  return undefined;
};
export default getFormattedDistance;
